export default "__VITE_ASSET__66ca02e6__"